export const PlantDesignRegistrationHolderPage = {
  registrationTypeLabel: 'Type of registration holder',
  organisationSearchLabel: 'ABN, ACN and business name',
  registeredBusinessNameLabel: 'Would you like to add a registered business name to this registration? (optional)',
  registeredBusinessAddressLabel: 'Registered business address',
  mailingAddressLabel: 'Mailing address',
  isMailingAddressSameAsResidentialAddressLabel: 'Same as residential address',
  isMailingAddressSameAsBusinessAddressLabel: 'Same as business address',
  organisationEmailAddressLabel: 'Organisation email address',

  contactMethodToAddLabel: 'Preferred contact method',
  secondaryContactMethodToAddLabel: 'What type of secondary contact method would you like to add?',

  residentialAddressLabel: 'Residential address',

  individualHolderIsRegistrationHolderLabel: 'Are you the registration holder?',
  individualHolderIsRegistrationHolderHelpMessage:
    'If you are the registration holder, we will add your details to this section.',

  holderFirstNameLabel: 'First name',
  holderMiddleNameLabel: 'Middle name(s) (optional)',
  holderLastNameLabel: 'Last name',
  holderEmailAddressLabel: 'Email address',
  reasonToRegisterInNSWLabel: 'Reason for registering in NSW',
};
